import React from 'react';
import './ResultViewer.css';

const ResultViewer = ({ 
  originalImageUrl, 
  resultImageUrl, 
  isConverting, 
  progress, 
  status,
  resultTitle 
}) => {
  return (
    <div className="result-viewer">
      <h2>转换结果</h2>
      
      {isConverting && (
        <div className="progress-container">
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="progress-text">{status}</div>
        </div>
      )}
      
      <div className="result-images">
        <div className="image-container">
          <h3>原图</h3>
          <img 
            src={originalImageUrl} 
            alt="原始图片" 
            className="result-image"
          />
        </div>
        
        <div className="image-container">
          <h3>{resultTitle || '处理后图片'}</h3>
          {resultImageUrl ? (
            <>
              <img 
                src={resultImageUrl} 
                alt="转换后的图片" 
                className="result-image"
              />
              <a 
                href={resultImageUrl} 
                download="styled_image.jpg"
                className="download-button"
              >
                下载图片
              </a>
            </>
          ) : (
            <div className="placeholder">等待处理...</div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResultViewer; 